// extracted by mini-css-extract-plugin
module.exports = {"WrapperRowAvailability":"RowAvailability_WrapperRowAvailability__FJMNA","inStock":"RowAvailability_inStock__FegPm","onOrder":"RowAvailability_onOrder__ip3nb"};